import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  Tooltip,
  Box,
} from '@mui/material';
import { Link, useParams } from 'react-router';
import { TypographySmallTitle } from './DocumentDetailsLeft';
import { IDocumentUnscoped, IDocumentUnscopedExtraction } from '../../../types/my-types';
import SentBadge from '../../common/SentBadge';
import CollapsedTitleWithTooltip from '../../common/CollapsedTitleWithTooltip';
import { DocumentDetailsParamTypes } from '../../../pages/DocumentDetailsPage';
import PreviewIcon from '@mui/icons-material/Preview';
import DeleteExtraction from '../../extractionBatches/details/DeleteExtraction';
import { useTheme } from '@mui/material/styles';
import { compactTableStyles } from '../../common/tableStyles';
import { LinkTableStyled } from '../../common/StyledComponents';

interface IExtractionListProps {
  documentData: IDocumentUnscoped;
}

const ExtractionList = ({ documentData }: IExtractionListProps) => {
  const { dpid, documentId } = useParams<DocumentDetailsParamTypes>();
  const theme = useTheme();

  if (!documentId) {
    return null;
  }

  const extractions = documentData?.extractions;

  return (
    <div style={{ marginTop: '20px' }}>
      <TypographySmallTitle>EXTRACTIONS</TypographySmallTitle>

      {extractions && extractions.length > 0 ? (
        <Box sx={{ ...compactTableStyles.containerSx, mt: 1 }}>
          <Table sx={{ ...compactTableStyles.tableSx, minWidth: 0 }}>
            <TableHead sx={compactTableStyles.tableHeadSx}>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody sx={compactTableStyles.tableBodySx}>
              {extractions.map((extraction: IDocumentUnscopedExtraction, index: number) => {
                return (
                  <TableRow key={index}>
                    <TableCell>
                      {extraction.extraction_batch_label ? (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <LinkTableStyled
                            to={`/data-pools/${dpid}/extraction-batch/${extraction.extraction_batch}/details`}
                            data-cy={`link-extraction-batch-details-${extraction.extraction_batch_label}`}
                          >
                            <CollapsedTitleWithTooltip
                              title={extraction.extraction_batch_label}
                              charsFirstAndLast={15}
                            />
                          </LinkTableStyled>
                          <SentBadge verified={extraction.verified_at || ''} />
                        </Box>
                      ) : (
                        'Deleted'
                      )}
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Link
                          to={`/data-pools/${dpid}/extraction-batch/${extraction.extraction_batch}/review/${extraction.id}`}
                          style={{ textDecoration: 'none' }}
                          data-cy={`link-review-extraction-${extraction.extraction_batch_label}`}
                        >
                          <Tooltip
                            placement="top"
                            title={`Review`}
                            disableFocusListener
                            disableTouchListener
                          >
                            <PreviewIcon
                              style={{
                                color: theme.palette.custom.lightGreen,
                                paddingTop: '5px',
                                fontSize: '21px',
                              }}
                            />
                          </Tooltip>
                        </Link>

                        <DeleteExtraction
                          extractionId={extraction.id}
                          extractionBatchLabel={extraction.extraction_batch_label}
                          iconSize="small"
                        />
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Box>
      ) : (
        <Typography style={{ fontSize: '13px' }}>No extractions found.</Typography>
      )}
    </div>
  );
};

export default ExtractionList;
